export default __webpack_public_path__ + "assets/videoShareYoutube.a47dab09.gif";